import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import RequireAuth from './components/RequireAuth';
import AdminLogin from './components/AdminLogin';
import { SnackbarProvider } from './components/SnackbarContext';

const AdminDasboard = lazy(() => import('./components/AdminDashboard'));

const App: React.FC = () => {
  return (
    <SnackbarProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Dashboard />} />

            {/* login */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* protect all admin routes */}
            <Route
              path="/admin/*"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <RequireAuth>
                    <AdminDasboard />
                  </RequireAuth>
                </Suspense>
              }
            />

            {/* optional: catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </SnackbarProvider>
  );
};

export default App;
